import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';
import SelectionModal from '../SelectionModal';
// icons
import MfeDashAllIcon from 'zignal-landscape/lib/Icon/MfeDashAllIcon';

const TITLE = 'Curated Datasets';
const FILTERS = [{label: 'All', icon: MfeDashAllIcon }];

const CuratedDatasetModal = ({
  campaignId = '',
  onClose = noop,
  navigateBackBone = noop
}) => {
  const [selectedModel, setSelectedModel] = useState(null);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);

  // filter out curated datasets that are already subscribed to
  const unfilteredModels = Account.get('curatedDatasets') || [];
  const datasets = Account.getActiveCampaign().get('candidates') || [];
  const subscribedToIds = datasets.map((dataset) => dataset.get('subscribesTo'));
  const models = unfilteredModels.filter((model) => !subscribedToIds.includes(model.id));

  const items = models.map((model) => {
    const { id, name: label, notes: subtext, es_tag_id } = model;
    return { id, label, subtext, es_tag_id, model };
  });

  const createSubscribedDataset = useCallback(async () => {
    try {
      const { id: subscribesTo } = selectedModel;
      const user_name = Account.get('user').getPrettyName();
      const user = Account.get('user').get('id');
      const res = await fetch(`/api/campaigns/${campaignId}/profiles`, {
        method: 'POST',
        body: JSON.stringify({ subscribesTo, user_name, user }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      if (res.ok) {
        const json = await res.json();
        if (!json.id) {
          throw new Error('Failed to create subscribed dataset');
        }
        window.location.href = `/data/campaigns/${campaignId}/profiles/edit/${json.id}/`;
      } else {
        throw new Error('Failed to subscribe to curated dataset');
      }
    } catch (error) {
      console.error(error);
      setSelectedModel(null);
      setIsConfirmDisabled(false);
      onClose();
    }
  }, [campaignId, selectedModel, setSelectedModel, setIsConfirmDisabled, navigateBackBone]);

  const onClickItem = useCallback((e, model) => {
    setSelectedModel(model);
    setIsConfirmDisabled(false);
  }, [setSelectedModel, setIsConfirmDisabled]);

  const onModalClose = useCallback(() => {
    setSelectedModel(null);
    setIsConfirmDisabled(false);
  }, [setSelectedModel, setIsConfirmDisabled]);

  const onModalConfirm = useCallback(() => {
    setIsConfirmDisabled(true);
    createSubscribedDataset();
  }, [setIsConfirmDisabled, createSubscribedDataset]);

  return (<>
    <SelectionModal
      title={TITLE}
      items={items}
      onClose={onClose}
      onClickItem={onClickItem}
      filters={FILTERS}
      hideAddButton
    />
    <ConfirmationModal
      isOpen={selectedModel}
      size="small"
      title={'Subscribe to Curated Dataset'}
      confirmText={'Subscribe'}
      onConfirm={onModalConfirm}
      onCancel={isConfirmDisabled ? noop : onModalClose}
      disableConfirm={isConfirmDisabled}
    >
      {'Would you like to subscribe to '}<b>{selectedModel?.name}</b>?
    </ConfirmationModal>
  </>);
};

CuratedDatasetModal.propTypes = {
  campaignId: PropTypes.string,
  onClose: PropTypes.func,
  navigateBackBone: PropTypes.func,
};

export default CuratedDatasetModal;
